import React from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  TextField, Button, Box, Typography, FormControlLabel, Checkbox,
} from '@mui/material';
import Colors from '../../../components/ui/Colors';

export default function ColumnOverrideDialog(props) {
  const { open, columnName, currentDefinition, onClose, onSubmit, submitting } = props;

  const [description, setDescription] = React.useState('');
  const [type, setType] = React.useState('');
  const [redacted, setRedacted] = React.useState(false);

  React.useEffect(() => {
    if (open) {
      setDescription((currentDefinition && currentDefinition.description) || '');
      setType((currentDefinition && currentDefinition.type) || '');
      setRedacted(!!(currentDefinition && currentDefinition.redacted));
    }
  }, [open, currentDefinition]);

  const handleSubmit = () => {
    onSubmit({ description, type, redacted });
  };

  return (
    <Dialog open={!!open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        Override column manually
        <Typography variant="caption" component="div" color="text.secondary" sx={{ fontFamily: 'monospace' }}>
          {columnName}
        </Typography>
      </DialogTitle>
      <DialogContent dividers>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 0.5 }}>
          <TextField
            label="Description"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            multiline
            minRows={2}
            fullWidth
          />
          <TextField
            label="Type"
            value={type}
            onChange={(e) => setType(e.target.value)}
            helperText="e.g. string, int, decimal, date, timestamp"
            fullWidth
          />
          <FormControlLabel
            control={<Checkbox checked={redacted} onChange={(e) => setRedacted(e.target.checked)} />}
            label="Redacted (PII)"
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={submitting}>Cancel</Button>
        <Button
          variant="contained"
          onClick={handleSubmit}
          disabled={submitting}
          sx={{ backgroundColor: Colors.primary }}
        >
          {submitting ? 'Saving…' : 'Save override'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
